import styled, { css } from "styled-components";
import { COLOR_BLACK, COLOR_WHITE } from "../constants/colors";
import { Body1, Heading6, Subtitle1 } from "./Typography";

type ButtonVariant = "primary" | "secondary";
type ButtonSize = "lg" | "md" | "sm";

type ButtonProps = {
  variant?: ButtonVariant;
  size?: ButtonSize;
  disabled?: boolean;
};

const Button = styled.button<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  border: none;

  &:hover {
    box-shadow: none;
  }

  ${(props) =>
    props.size === "sm" &&
    css`
      ${Body1}
      padding: 10px 20px;
    `}
  ${(props) =>
    props.size === "md" &&
    css`
      ${Subtitle1}
      padding: 12px 24px;
    `}
  ${(props) =>
    props.size === "lg" &&
    css`
      ${Heading6}
      padding: 12px 32px;
    `}

  ${(props) =>
    props.variant === "primary" &&
    css`
      background: ${COLOR_WHITE};
      color: ${COLOR_BLACK};

      ${!props.disabled &&
      css`
        &:hover {
          background: ${COLOR_BLACK};
          color: ${COLOR_WHITE};
        }
      `}
    `}
  ${(props) =>
    props.variant === "secondary" &&
    css`
      background: ${COLOR_BLACK};
      color: ${COLOR_WHITE};

      ${!props.disabled &&
      css`
        &:hover {
          filter: brightness(85%);
        }
      `}
    `}

  &:disabled {
    background-color: darkgray;
    color: ${COLOR_BLACK};
  }
`;

export default Button;

Button.defaultProps = {
  variant: "primary",
  size: "md",
  disabled: false,
};
